import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import API_SEARCH from '../../../api/apiSearch';
import IconDeleteBlue from '../../../assets/icons/IconDeleteBlue';
import IconDetailBlue from '../../../assets/icons/IconDetailBlue';
import IconEditBlue from '../../../assets/icons/IconEditBlue';
import IconAddBlue from '../../../assets/icons/IconAddBlue';
import SearchbarMenu from '../../../components/Searchbar/SearchbarMenu';
import ActionType from '../../../redux/reducer/globalActionType';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_USER_DELETE,
    MASTER_DATA_USER_INSERT,
    MASTER_DATA_USER_UPDATE,
    MASTER_DATA_USER_VIEW
} from '../../../constants/menuPermissionConstant';
import Alert from '../../../components/Alert/Alert';
import TableNexcare from '../../../components/Table/TableNexcare';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';

class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            columnsUser: [
                {
                    title: "Nama Pengguna",
                    dataIndex: "username",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Nama Lengkap",
                    dataIndex: "alias_name",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (_, user) => `${user.first_name} ${user.last_name}`,
                },
                {
                    title: "Kategori Role",
                    dataIndex: "category_user",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Waktu Dibuat",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Waktu Diubah",
                    dataIndex: "updated_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data === "" ? "-" : moment.utc(data).format('DD/MM/YYYY HH:mm')}`,
                },
                {
                    title: "Diubah Oleh",
                    dataIndex: "updated_by",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btnuserdetail" onClick={() => this.handleDetailUser(data)}><IconDetailBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer mr-5" id="btnuseredit" onClick={() => this.handleEditUser(data)}><IconEditBlue /></span>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <span className="cursor-pointer" id="btnuserdelete" onClick={() => this.handleConfirmDeleteUser(data)}><IconDeleteBlue /></span>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            data: [],
            keyword: '',
            user: {},
            showSuccessAlert: false,
            showConfirmAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateUser = () => {
        API_MASTER_DATA.getInitiateUser(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListUser = () => {
        API_MASTER_DATA.getListUser(this.state.pagination.current, this.state.pagination.pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    })
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getInitiateSearchUser = keyword => {
        API_SEARCH.getInitiateUser(keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchUser = keyword => {
        API_SEARCH.getListUser(this.state.pagination.current, this.state.pagination.pageSize, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                        data: getContent(res)
                    });
                }
            }).catch(err => {
                this.setState({ loading: false });
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleEnterSearch = keyword => {
        this.handleSearch(keyword, true);
    }

    handleSearch = async (keyword, resetToFirstPage) => {
        if (this.state.keyword === '' || resetToFirstPage) {
            await this.setState({
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: 1
                },
                keyword
            });
        } else {
            await this.setState({
                loading: true,
                keyword
            });
        }
        this.handleSetQueryParams();
        this.getInitiateSearchUser(keyword);
        this.getSearchUser(keyword);
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            async () => {
                await this.handleSetQueryParams();
                this.updateQueryParams(false);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            async () => {
                await this.handleSetQueryParams();
                this.updateQueryParams(false);
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                loading: true,
                filter: sorter
            },
            async () => {
                await this.handleSetQueryParams();
                this.updateQueryParams(false);
            }
        );
    }

    handleDetailUser = user => {
        this.props.history.push(`/master-data/user/detail/${user.id}`)
    }

    handleEditUser = user => {
        this.props.history.push(`/master-data/user/edit/${user.id}`)
    }

    handleConfirmDeleteUser = user => {
        this.setState({
            showConfirmAlert: true,
            user
        })
    }

    handleDeleteUser = () => {
        this.setState({ showConfirmAlert: false })

        const data = {
            updated_at: this.state.user.updated_at,
            category_user: this.state.user.category_user
        }

        API_MASTER_DATA.deleteDataUser(this.state.user.id, data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert: true })
                setTimeout(async () => {
                    this.setState({
                        showSuccessAlert: false,
                        pagination: {
                            ...this.state.pagination,
                            current: 1
                        },
                        keyword: ''
                    })
                    await this.handleSetQueryParams();
                    this.updateQueryParams();
                }, 1500)
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleSetQueryParams = () => {
        const params = new URLSearchParams();
        params.set('page', this.state.pagination.current);
        params.set('limit', this.state.pagination.pageSize);
        params.set('keyword', this.state.keyword);

        const queryString = params.toString();
        const newLocation = { ...this.props.location, search: `?${queryString}` };
        this.props.history.push(newLocation);
    }

    updateQueryParams = resetToFirstPage => {
        const params = new URLSearchParams(this.props.location.search);
        const page = params.get('page') || 1;
        const limit = params.get('limit') || 10;
        const keyword = params.get('keyword') || '';

        this.setState({
            pagination: {
                ...this.state.pagination,
                current: parseInt(page),
                pageSize: parseInt(limit)
            },
            keyword
        }, async () => {
            if (keyword !== '') {
                return this.handleSearch(keyword, resetToFirstPage);
            }

            if (resetToFirstPage) {
                await this.setState({ page: 1 });
                this.handleSetQueryParams();
            }

            this.getInitiateUser();
            this.getListUser();
        });

    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateUser();
        this.getListUser();

        this.updateQueryParams(false);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                <LoadingLoader show={this.state.loading} />
                <SearchbarMenu handleSearch={this.handleEnterSearch} placeholder="Username" />
                <div className="w-full flex justify-between mb-5">
                    <div></div>
                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_INSERT]} userPermission={this.props.userDetail.permissions}>
                        <NavLink
                            to={ROUTER_CONSTANT.MASTER_DATA_USER_ADD}
                            className="rounded-full bg-white text-darkblue font-bold border-2 border-white px-3 py-1 flex items-center"
                            activeClassName="bg-blue-200 border-2 border-white"
                            id="btnadduser"
                        >
                            <IconAddBlue />
                            <span className="ml-2">Tambah</span>
                        </NavLink>
                    </CheckPermissionComponent>
                </div>
                <div className="bg-white rounded-2xl">
                    <TableNexcare
                        column={this.state.columnsUser}
                        dataTable={this.state.data}
                        pagination={this.state.pagination}
                        onPage={this.handleSelectedPage}
                        onPageSize={this.handleSelectedPageSize}
                        onSorter={this.handleSorter}
                    />
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Menghapus Pengguna!" />
                <Alert show={this.state.showConfirmAlert} icon="delete" button={true} title="Apakah Anda yakin menghapus pengguna ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleDeleteUser()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(User);